// src/components/ProductGrid.tsx
import ProductCard from './ProductCard';
import { Product } from '../types';
import ProductCardSkeleton from './ProductCardSkeleton';

type ProductGridProps = {
  products: Product[];
  loading: boolean;
  variant?: 'grid' | 'carousel';
};

const ProductGrid = ({ products, loading, variant = 'grid' }: ProductGridProps) => {
  const isCarousel = variant === 'carousel';
  const containerClassName = isCarousel
    ? 'flex snap-x snap-mandatory gap-3 overflow-x-auto overscroll-x-contain pb-3 sm:gap-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'
    : 'grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5';
  const itemClassName = isCarousel
    ? 'w-[46%] min-w-[46%] snap-start sm:w-[31%] sm:min-w-[31%] md:w-[23%] md:min-w-[23%] xl:w-[19%] xl:min-w-[19%]'
    : '';

  // --- Loading State ---
  if (loading) {
    return (
      <div className={containerClassName}>
        {/* Render 12 skeletons to fill the initial view */}
        {Array.from({ length: isCarousel ? 6 : 12 }).map((_, index) => (
          <div key={index} className={itemClassName}>
            <ProductCardSkeleton />
          </div>
        ))}
      </div>
    );
  }

  // --- Empty State ---
  if (!products.length) {
    return null;
  }

  // --- Content State ---
  return (
    <div className={containerClassName}>
      {products.map((product) => (
        <div key={product.id} className={itemClassName}>
          <ProductCard product={product} />
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
